// extracted by mini-css-extract-plugin
export default {"button":"FastForwardButton_button__FuOfl"};